import { t } from "i18next";
import type {
  ReportExportType,
  ReportTempo,
  ReportType,
  ResourceType,
} from "~/types/api";

export const ReportTempoEnum = {
  DAILY: 0,
  WEEKLY: 1,
  MONTHLY: 2,
} as const;

export const ReportTypeEnum = {
  REGULAR: 0,
  TREND: 1,
  TEMPLATE: 2,
} as const;

export const ReportExportTypeEnum = {
  EXCEL: 0,
  PDF: 1,
  CSV: 2,
} as const;

export const ResourceTypeEnum = {
  TAG: 0,
  GATEWAY: 1,
  SENSOR: 2,
  COMPANY: 3,
  USER: 4,
  REPORT: 5,
  AUDIT_LOG: 6,
  ALARM: 7,
} as const;

export function reportTempoToString(tempo: ReportTempo): string {
  return t(`reports.tempo.${tempo}`);
}

export function reportTypeToString(type: ReportType): string {
  return t(`reports.types.${type}`);
}

export function reportExportTypeToString(type: ReportExportType): string {
  return t(`reports.exportTypes.${type}`);
}

export function resourceTypeToString(type: ResourceType): string {
  return t(`resourceType.type.${type}`);
}

export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
